import * as React from "react";
import { forwardRef } from "react";
const SvgAccent = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 8, viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.666667 7.96289C4.71676 7.96289 8 4.63136 8 0.521715C8 -1.5077 8 3.2276 8 0.521715V7.96289H0.666667Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M0.666667 7.96289C0.44194 7.96289 0.230469 7.96289 0 7.96289H0.666667Z", fill: "white" }));
const ForwardRef = forwardRef(SvgAccent);
export { ForwardRef as ReactComponent };
